import React, { Component } from 'react';

class MakeModelCelRender extends Component {
    render() {
        return  <div>
                    {this.props.data.icn.make} - {this.props.data.icn.model}
                </div>
    }
}

export default MakeModelCelRender;


// WEBPACK FOOTER //
// ./src/components/table/cellRenderers/MakeModelCelRender.js